import { render, staticRenderFns } from "./my-airdrop-treasury.vue?vue&type=template&id=517d7644&scoped=true&"
import script from "./my-airdrop-treasury.vue?vue&type=script&lang=ts&"
export * from "./my-airdrop-treasury.vue?vue&type=script&lang=ts&"
import style0 from "./my-airdrop-treasury.vue?vue&type=style&index=0&id=517d7644&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d7644",
  null
  
)

export default component.exports